class ConfigService {
  constructor() {
    this._config = {};
    this._isLoaded = false;
  }

  async load() {
    if (this._isLoaded) {
      return;
    }

    try {
      const fetchJson = async (path) => {
        try {
          const res = await fetch(path, { cache: "no-cache" });
          if (!res.ok) return null;
          return await res.json();
        } catch (_) {
          return null;
        }
      };

      // Prefer /config.json. If missing (common in local dev), fallback to /config.dev.json
      let data = await fetchJson("/config.json");
      if (!data) {
        data = await fetchJson("/config.dev.json");
      }
      if (!data) {
        throw new Error(
          "Failed to fetch config.json (and config.dev.json fallback)"
        );
      }

      console.log("Configuration loaded successfully:", data);
      this._config = data;
      this._isLoaded = true;
    } catch (error) {
      console.error("CRITICAL: Could not load app configuration!", error);
      throw error;
    }
  }

  get(key) {
    if (!this._isLoaded) {
      console.warn(
        `Config service has not been loaded yet, but tried to access key: "${key}"`
      );
    }
    return this._config[key];
  }
}

const instance = new ConfigService();
export default instance;
